import React from "react";

export default function SuccessStep({ selectedOffer }) {
  const lenderName = selectedOffer?.lender_name || "CredFin";

  const handleHomeRedirect = () => {
    // Redirect the user back to the dashboard or home page
    window.location.href = "/"; 
  };

  return (
    <div className="w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] font-atkinson flex flex-col relative pb-[40px]">
      
      {/* Header & Progress Bar */}
      <div className="px-5 pt-6 pb-4 border-b border-transparent">
        <div className="flex justify-center mb-4">
          <div className="text-center leading-none">
            <h1 className="text-[#205A6D] font-bold text-[22px] tracking-tight">
              {lenderName}
            </h1>
            <p className="text-[#7ea4b1] text-[9px] font-semibold tracking-widest mt-1 uppercase">Loans made Easy</p>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <button className="w-6 h-6 flex items-center justify-start text-gray-400 cursor-not-allowed">
            {/* Disabled back button for success screen */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
          
          <div className="flex-1 mx-4 h-[4px] bg-[#e6f4ed] rounded-full overflow-hidden">
            <div className="h-full bg-[#12f280] w-[100%] rounded-full"></div>
          </div>
          <span className="text-[12px] text-gray-500 font-medium">100%</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-5 pt-2 flex-1">
        
        {/* Success Card */}
        <div className="bg-[#EBFBF4] border border-[#D1EFE2] rounded-[16px] p-5 mb-8 relative overflow-hidden">
          {/* Green Checkmark Icon */}
          <div className="absolute top-5 right-5 w-7 h-7 bg-[#12f280] rounded-full flex items-center justify-center shadow-sm">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>

          <div className="flex items-center gap-1.5 mb-1">
            <span className="font-bold text-[20px] text-[#1b1b1b]">Congratulations</span>
            <span className="text-[20px]">🎉</span>
          </div>
          
          <p className="text-[13px] text-[#1b1b1b] font-bold mb-6">
            Your loan application is successful.
          </p>
          
          <p className="text-[12px] text-[#555] leading-relaxed pr-4">
            We have received your Loan Application, you will shortly receive confirmation from us.
          </p>
        </div>

        <hr className="border-[#f0f0f0] mb-8" />

        {/* Assistance Details */}
        <div className="flex flex-col gap-6">
          <p className="text-[13px] font-bold text-[#1b1b1b]">
            Need immediate assistance?
          </p>

          <div>
            <p className="text-[11px] font-bold text-[#1b1b1b] tracking-wider mb-1">EMAIL US</p>
            <p className="text-[13px] text-[#8b8b8b]">
              Our friendly team is here to help. <span className="font-bold text-[#1b1b1b]">hello@digitmoney.in</span>
            </p>
          </div>

          <div>
            <p className="text-[11px] font-bold text-[#1b1b1b] tracking-wider mb-1">WHATSAPP</p>
            <p className="text-[13px] font-bold text-[#1b1b1b]">
              +91 70390 00959
            </p>
          </div>
        </div>

      </div>

      {/* Fixed Bottom Layout */}
      <div className="px-5 mt-auto pt-6 flex flex-col items-center">
        <button 
          onClick={handleHomeRedirect}
          className="w-full bg-black text-white font-bold text-[16px] rounded-[14px] py-[18px] active:scale-[0.98] transition-transform mb-4"
        >
          Back to home
        </button>
        <p className="text-[11px] text-[#b3b3b3] font-medium">
          We're here to help!
        </p>
      </div>
    </div>
  );
}